import type { ReactComponentLike } from 'prop-types';

import { AuthGuard } from '../components/authentication/auth-guard';

type Config = {
  includeNonAdvisoryUser?: boolean;
};
export function withClientGuard(Component: ReactComponentLike, config?: Config) {
  function WithClientGuard(props: Record<string, unknown>) {
    return (
      <AuthGuard forClient forNonAdvisoryUser={config?.includeNonAdvisoryUser === true}>
        <Component {...props} />
      </AuthGuard>
    );
  }

  return WithClientGuard;
}
